import MspState from 'components/models/MspState';
import OptimizelyApi, { experiments } from 'client/GrowthEngineering/OptimizelyApi';
import PageNavigationUtil from 'client/util/PageNavigationUtil';
import hashString from 'client/GrowthEngineering/utilities/hashString';

function getOptimizelyVariations() {
  const optimizelyVariations = {};
  if (window.optimizely && window.optimizely.get) {
    const state = window.optimizely.get('state');
    Object.keys(experiments).forEach((experimentKey) => {
      const experiment = experiments[experimentKey];
      const variation = OptimizelyApi.getVariation(experiment, state);
      optimizelyVariations[experimentKey] = variation;
    });
  }

  return optimizelyVariations;
}

function getOrgId() {
  return !MspState.displayMtpView
    ? { orgId: () => hashString(MspState.orgId) }
    : {};
}

function getProviderId() {
  return MspState.isAnMspOrChild
    ? hashString(MspState.providerId)
    : undefined;
}

export default {
  eventProps: {
    optimizelyVariations: () => getOptimizelyVariations(),
    ...getOrgId(),
    providerId: () => getProviderId(),
  },
  mixinHooks: {
    // If page is using the legacy router, fall back to the page hash
    $page: (Vue) => (!Vue.$route ? PageNavigationUtil.getLocationHashPath() : undefined),
  },
};
